export const ONE = 1;
export const ZERO = 0;
export const ONE_SECOND = 1000;

const THIRTY_SECONDS = 30000;
const ONE_MINUTE = 60000;
const TWO_MINUTES = 120000;
const FIVE_MINUTES = 300000;

export const RETRY_MAP = [
  THIRTY_SECONDS,
  ONE_MINUTE,
  TWO_MINUTES,
  FIVE_MINUTES,
];
